import map from 'ramda/src/map'
import call from 'ramda/src/call'
import pick from 'ramda/src/pick'
import compose from 'ramda/src/compose'

export default compose(map(call), pick(['lat', 'lng']))



// WEBPACK FOOTER //
// ./src/helpers/map/toLatLngLiteral.js